import React, { Component, PropTypes } from "react";

import { NitroSingleSelect, NitroMultipleSelect } from "nitro-components";

class VehicleFilter extends Component {
  handleSelectChange = (name, selected) => {
    this.props.onChange(name, selected);
  };
  handleMultipleSelectChange = (name, value) => {
    const selected = value.map(v =>
      this.props.options.find(option => option.value === v));
    this.props.onChange(name, selected);
  };

  render() {
    const { name, selected, options, disabled, type, placeholder } = this.props;

    if (type) {
      let value = [];

      if (selected.length === 1 && typeof selected[0] === "string") {
        value = selected;
      } else {
        if (selected) {
          value = selected.map(s => s.value);
        }
      }

      return (
        <NitroMultipleSelect
          placeholder={placeholder}
          value={value}
          options={options}
          disabled={disabled}
          alignLeft
          action={val => this.handleMultipleSelectChange(name, val.value)}
        />
      );
    }

    const value = selected ? selected.value : "";

    return (
      <NitroSingleSelect
        placeholder={placeholder}
        value={value}
        options={options}
        disabled={disabled}
        alignLeft
        action={option => this.handleSelectChange(name, option)}
      />
    );
  }
}

VehicleFilter.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.array,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.any,
  type: PropTypes.bool.isRequired,
  placeholder: PropTypes.string
};

export default VehicleFilter;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/components/VehicleFilter.js